<script setup lang="ts">
import DefaultModalBase from "../DefaultModalBase.vue";
import {useOrderStore} from "../../../store/orders"
import {useModalStore} from "../../../store/modal"
import {computed, onMounted, ref} from "vue";

const loading = ref(false)
const store = useOrderStore()
const modalStore = useModalStore()
const is_unprocessed = ref(false)
const reason = ref('')

const disabled = computed(() => loading.value || !reason.value)

const unprocessOrder = async () => {
    loading.value = true
    await store.unprocessOrder(reason.value)

    loading.value = false
    is_unprocessed.value = true
}

onMounted(async () => {
})
</script>

<template>
<DefaultModalBase :heading="is_unprocessed ? 'Order Unprocessed' : 'Unprocess Order'" :icon="is_unprocessed ? 'check-all' : 'cross-default'" :loading :refresh="is_unprocessed">

    <div class="call-assign-container">
        <brand-form-textarea label="Reason for unprocessing." v-model="reason" v-if="!is_unprocessed"/>
        <brand-button @click="unprocessOrder()" :disabled v-if="!is_unprocessed">Unprocess Order</brand-button>
        <brand-button variant="secondary" v-if="is_unprocessed" @click="modalStore.close(true)">Done</brand-button>
    </div>
</DefaultModalBase>
</template>

<style scoped lang="scss">
.call-assign-container {
    display: flex;
    flex-direction: column;
    gap: 3rem;
}
</style>